export const CLICKED_EDIT_BRIEF_COOKIE_KEY = 'bff_pro_listings_clicked_edit_brief';
